import scale from '../../../../assets/images/Campaign/Colour/Anna/scale.png';
import dumbell from '../../../../assets/images/Campaign/Colour/Mack/dumbell.png';
import ig from '../../../../assets/images/Campaign/Colour/Dina/ig.png';
import forbes from '../../../../assets/images/Campaign/Colour/Payal/forbes.png';
import portrait from '../../../../assets/images/Campaign/Colour/Acton/portrait.png';
import bamboo from '../../../../assets/images/Campaign/Colour/Aleksandra/bamboo.png';
import family from '../../../../assets/images/Campaign/Colour/Ziggy/family.png';
import yoga from '../../../../assets/images/Campaign/Colour/Sonia/yoga.png';

import annaBefore from '../../../../assets/images/Campaign/Colour/Anna/anna_before.jpg';
import mackBefore from '../../../../assets/images/Campaign/Colour/Mack/mack_before.jpg';
import dinaBefore from '../../../../assets/images/Campaign/Colour/Dina/dina_before.png';
import payalBefore from '../../../../assets/images/Campaign/Colour/Payal/payal_before.png';
import actonBefore from '../../../../assets/images/Campaign/Colour/Acton/acton_before.png';
import aleksandraBefore from '../../../../assets/images/Campaign/Colour/Aleksandra/aleksandra_before.png';
import ziggyBefore from '../../../../assets/images/Campaign/Colour/Ziggy/ziggy_before.png';
import soniaBefore from '../../../../assets/images/Campaign/Colour/Sonia/sonia_before.png';

import { ColourTheme } from '../../../../types/ColourTheme';

export const personaToProp: Record<ColourTheme, string> = {
  [ColourTheme.cerulean]: scale,
  [ColourTheme.skyblue]: dumbell,
  [ColourTheme.pomegranate]: ig,
  [ColourTheme.orchidpink]: forbes,
  [ColourTheme.greensea]: portrait,
  [ColourTheme.jade]: bamboo,
  [ColourTheme.carrot]: family,
  [ColourTheme.sunflower]: yoga,
  [ColourTheme.default]: scale,
};

export const personaToBefore: Record<ColourTheme, string> = {
  [ColourTheme.cerulean]: annaBefore,
  [ColourTheme.skyblue]: mackBefore,
  [ColourTheme.pomegranate]: dinaBefore,
  [ColourTheme.orchidpink]: payalBefore,
  [ColourTheme.greensea]: actonBefore,
  [ColourTheme.jade]: aleksandraBefore,
  [ColourTheme.carrot]: ziggyBefore,
  [ColourTheme.sunflower]: soniaBefore,
  [ColourTheme.default]: annaBefore,
};